/* eslint-disable camelcase */
import React from 'react'
import {
  Details,
  Flex,
} from '@nautilusjs/component-core'
import { Box } from '@maui/elements'
import isEmpty from 'lodash/isEmpty'
import { Grid } from '../Grid'

const DomainDetails = ({ data = {} }) => {
  if (!data) return

  const {
    asn,
    location,
    name_servers: servers,
  } = data

  const asnNumber = asn?.number
  const formattedLocation = location && `${location.city}, ${location.country}`

  if (isEmpty(servers) && !asnNumber && !location) {
    return null
  }

  return (
    <Grid>
      <Grid.Cell columns={2} style={{ position: 'relative' }}>
        { !isEmpty(servers) && (
          <Details>
            <Details.Term>Base Domains</Details.Term>
            <Details.Definition>
              { servers.map((server, index) => <Box key={index}>{ server.value }</Box>) }
            </Details.Definition>
          </Details>
        )}

        <Flex css={{
          flexWrap: 'wrap',
          marginTop: '1rem',
          marginBottom: '1rem',
          dt: {
            whiteSpace: 'nowrap',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
          },
          dd: {
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
          }
        }}>
          { asnNumber && (
            <Box width='50%'>
              <Details.Term>ASN</Details.Term>
              <Details.Definition>{asnNumber}</Details.Definition>
            </Box>
          )}
          { location && (
            <Box width='50%'>
              <Details.Term>GEO</Details.Term>
              <Details.Definition>{formattedLocation}</Details.Definition>
            </Box>
          )}
        </Flex>
      </Grid.Cell>
    </Grid>
  )
}

export default DomainDetails
